import { isUUID } from '@vrplatform/utils';

type OwnerAccessWhere = {
  userId: {
    _eq: string | null | undefined;
  };
  _or?: [
    {
      contact: {
        tenantId: {
          _eq: string;
        };
      };
    },
    {
      owner: {
        tenantId: {
          _eq: string;
        };
      };
    },
  ];
};

export function isOwnerPortalImpersonating({
  isUserPreview,
  queryTeamId,
}: {
  isUserPreview: boolean;
  queryTeamId: string | null;
}) {
  return isUserPreview || (!!queryTeamId && isUUID(queryTeamId));
}

export function isOwnerPortalTeamSwitchPending({
  isImpersonating,
  queryTeamId,
  activeTeamId,
}: {
  isImpersonating: boolean;
  queryTeamId: string | null;
  activeTeamId: string | null | undefined;
}) {
  if (!isImpersonating || !queryTeamId || !isUUID(queryTeamId)) {
    return false;
  }

  return queryTeamId !== activeTeamId;
}

export function getOwnerAccessWhere({
  isImpersonating,
  teamId,
  meId,
}: {
  isImpersonating: boolean;
  teamId: string | null | undefined;
  meId: string | null | undefined;
}): OwnerAccessWhere {
  if (!isImpersonating || !teamId) {
    return {
      userId: { _eq: meId },
    };
  }

  return {
    userId: { _eq: meId },
    _or: [
      {
        contact: {
          tenantId: { _eq: teamId },
        },
      },
      {
        owner: {
          tenantId: { _eq: teamId },
        },
      },
    ],
  };
}
